export { default, getStaticProps } from 'src/pages/Teams'
